import { inject, InjectionToken } from '@angular/core';
import { WINDOW_NAVIGATOR } from './window-navigator.token';


export const MMU_GLOBAL_PRIVACY_CONTROL = new InjectionToken<boolean>('Global Privacy Control Token', {
  providedIn: 'root',
  factory: (): boolean => {
    const navigator: Record<string, any> = inject(WINDOW_NAVIGATOR);
    return navigator['globalPrivacyControl'] ?? false;
  }
});
